import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.alert-types-index-page', () => {
  import('./internal/alert-types-index-page').then(({ default: Component }) => Component());
});
